import React, { useEffect, useState } from "react";
import DefaultModal from "../../default-modal/DefaultModal";
import { types } from "../../../helpers/eventEmitter";
import ModalHeader from "../../modal-header/ModalHeader";
import { Container } from "@mui/material";
import styles from "../Modals.styles";
import { connect, useDispatch } from "react-redux";
import EntityEditor from "../../../entity-editor/EntityEditor";
import { selectLeadgen } from "../../../../../modules/leadgen/selectors";
import ObjectEditor from "../../../object-editor/ObjectEditor";
import { receiveObjectByIdRequest } from "../../../../../modules/leadgen/actions/objects";
import type { RootState } from "../../../../../reducers";
import type { TypeEdit, Id } from "../../../../../../types/editor.types";
import type { EntityMainDetailsDTO } from "../../../../../../types/entity.types";

type Props = {
  entityMainDetails?: EntityMainDetailsDTO | null;
};
type entityDetailsState = EntityMainDetailsDTO | null;

const EntityObjectEditModal: React.FC<Props> = ({ entityMainDetails }) => {
  const dispatch = useDispatch();
  const [entityDetails, setEntityDetails] = useState<entityDetailsState>(null);
  const [editId, setEditId] = useState<Id | null>(null);
  const [entityId, setEntityId] = useState<Id | null>(null)
  const [typeEdit, setTypeEdit] = useState<TypeEdit | null>(null);

  const resetModalState = () =>  {
    setTypeEdit(null);
    setEntityId(null);
    setEditId(null);
    setEntityDetails(null);
  }
  // useEffect(() => {
  //   if (entityMainDetails) {
  //     setEntityDetails(entityMainDetails);
  //   }
  // }, [entityMainDetails]);
  const handleOpen = (type: TypeEdit, id: Id, entityObjectId?: Id) => {
    setTypeEdit(type);
    setEditId(id);
    setEntityId(entityObjectId ?? null);
    if (type === "entityEdit" && entityMainDetails) {
      setEntityDetails(entityMainDetails);
    }
  };

  useEffect(() => {
    if (editId) {
      dispatch(receiveObjectByIdRequest(editId));
    }
  }, [dispatch, editId]);

  return (
    <>
      <DefaultModal
        onOpen={handleOpen}
        onClose={resetModalState}
        nameEvent={types.openEntityObjectEditModal}
        modalType="search"
      >
        {({ closeModal }) => (
          <>
            <ModalHeader
              title={typeEdit === "entityEdit" ? "EDIT ENTITY" : "EDIT OBJECT"}
            />
            <Container id="container-entityObjectEditModal" sx={styles.contentBodyEdit}>
              {typeEdit === "entityEdit" ? (
                entityDetails ? (
                    <EntityEditor
                      closeModal={closeModal}
                      type={entityDetails.entity_type}
                      typeEdit={typeEdit}
                      entityId={editId}
                    />
                  ) : null
              ) : (
                <ObjectEditor
                  objectId={editId}
                  closeModal={closeModal}
                  typeEdit={typeEdit}
                  entityId={entityId}
                />
              )}
            </Container>
          </>
        )}
      </DefaultModal>
    </>
  );
};

function mapStateToProps(state: RootState): Props {
  const { entityMainDetails } = selectLeadgen(state);
  return { entityMainDetails: entityMainDetails ?? null };
}

export default connect(mapStateToProps)(EntityObjectEditModal);
